import { render, staticRenderFns } from "./CmgLargeOrderPromoCard.vue?vue&type=template&id=b1fcc4ce&scoped=true&lang=pug"
import script from "./cmg-large-order-promo-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-large-order-promo-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLargeOrderPromoCard.vue?vue&type=style&index=0&id=b1fcc4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fcc4ce",
  null
  
)

export default component.exports